"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWED_IMAGE_MIME_TYPES = exports.ALLOWED_IMAGE_TYPES = void 0;
exports.ALLOWED_IMAGE_TYPES = ['png', 'jpg', 'jpeg', 'webp'];
exports.ALLOWED_IMAGE_MIME_TYPES = exports.ALLOWED_IMAGE_TYPES.map((type) => `image/${type}`);
//# sourceMappingURL=allowed-types.js.map